import { Stack } from '@mui/material'
import { useRouter } from 'next/router'
import { Button, OrkaLogoType } from '@evocolabs/orkaui'
import Link from 'next/link'
import styles from './styles.module.scss'

const data = { btnText: 'Am I a Candidate?', path: '/SurveyPage' }

const Subheader = (): JSX.Element => {
  const { btnText, path } = data
  const router = useRouter()

  return (
    <Stack
      direction="row"
      alignItems="space-between"
      className={styles.subheader}
      id="mobile-subheader"
      display={{ xs: 'block', dl: 'none' }}
    >
      <Link href={'/'}>
        <OrkaLogoType />
      </Link>
      <Button
        variant="primary"
        onClick={() => {
          router.push(path)
        }}
        id={`orka-care-header-am-i-a-candidate`}
      >
        {btnText}
      </Button>
    </Stack>
  )
}

export default Subheader
